import OrderIsBeingProcessed from './order-is-being-processed.component';

export default OrderIsBeingProcessed;
